"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

var _ModalContent = _interopRequireDefault(require("./ModalContent"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

var Modal = function Modal(props) {
  var onClose = props.onClose,
      preventDefaultClose = props.preventDefaultClose,
      centerPositioning = props.centerPositioning,
      position = props.position,
      modalShadow = props.modalShadow,
      modalBorder = props.modalBorder,
      modalBorderRadius = props.modalBorderRadius,
      modalBackground = props.modalBackground,
      backgroundMaskColor = props.backgroundMaskColor,
      customZIndex = props.customZIndex;
  return React.createElement("div", {
    className: "gib-r-drpd-m-_ModalMask ".concat(centerPositioning && 'gib-r-drpd-m-_ModalMask-m-centered'),
    style: {
      background: backgroundMaskColor ? backgroundMaskColor : 'rgba(1, 1, 1, 0)',
      zIndex: customZIndex ? customZIndex : 20
    },
    onClick: function onClick(e) {
      e.stopPropagation();
      if (!preventDefaultClose) onClose();
    }
  }, React.createElement("div", {
    className: "gib-r-drpd-m-_Modal",
    style: {
      background: modalBackground ? modalBackground : 'white',
      borderRadius: modalBorderRadius ? modalBorderRadius : '0px',
      left: !centerPositioning && position.left ? position.left : 'auto',
      right: !centerPositioning && position.right ? position.right : 'auto',
      top: !centerPositioning && position.top ? position.top : 'auto',
      bottom: !centerPositioning && position.bottom ? position.bottom : 'auto',
      border: modalBorder === true ? '1px solid #bbbbbb' : modalBorder ? modalBorder : '0px solid white',
      boxShadow: modalShadow === true ? '0px 0px 10px 0px rgba(0,0,0,0.2)' : modalShadow ? modalShadow : '0px 0px 0px 0px rgba(0,0,0,0)'
    }
  }, React.createElement(_ModalContent.default, props)));
};

var _default = Modal;
exports.default = _default;